import styled from 'styled-components'

export const TR = styled.tr`
  background-color: #fff;
  box-shadow: rgb(170, 170, 170) 1px 1px 4px 0;
  border-radius: 5px;
  position: relative;
  cursor: pointer;

  &:hover {
    background-color: #000;
    color: #fff;
  }
`

export const TD = styled.td`
  font-size: 14px;
  font-weight: 600;
  text-align: center;
  line-height: 1;
  padding: 10px;
  white-space: nowrap;

  &:first-child {
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
  }

  &:last-child {
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
  }
`

export const RowIndex = styled.div`
  font-weight: 500;
`

export const School = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
`

export const SchoolAvatar = styled.img`
  width: 20px;
`

export const SchoolName = styled.span`
  color: rgb(56, 135, 214);
  font-weight: 500;
  white-space: nowrap;
`

export const Delta = styled.div<{ $value: number }>`
  color: ${({ $value }) => {
    if ($value > 0) return 'rgb(67, 177, 86)'
    if ($value < 0) return 'rgb(208, 26, 38)'
    return 'rgb(108, 117, 125)'
  }};
`
